import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Wraps protected app routes.
 * - While the auth state is loading, render nothing (avoid flashing the login screen).
 * - If logged out, redirect to /login while remembering the original target.
 * - If a `feature` is required and the user doesn't have it, redirect to /.
 * - If `superAdminOnly` is set and the user isn't super_admin, redirect to /.
 */
const ProtectedRoute = ({ children, feature, superAdminOnly = false }) => {
  const { user, checking, has } = useAuth();
  const location = useLocation();

  if (checking) {
    return (
      <div className="min-h-screen bg-surface flex items-center justify-center text-ink/40 text-sm">
        Loading…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (superAdminOnly && user.role !== 'super_admin') {
    return <Navigate to="/" replace />;
  }

  if (feature && !has(feature)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
